import React from "react";
import { enqueueSnackbar } from "notistack";
import { Modal3 } from "../../DIsplay/Modal/Modal3";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import Button1 from "../../form/Button1";

function TicketEditAirlinePnrModal({
  open,
  setOpen,
  initialPnrList,
  handleSave,
}) {
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    if (open) {
      const list = Array.isArray(initialPnrList) ? initialPnrList : [];
      const sanitize = (v) => (v ?? "").replace(/[^a-zA-Z0-9]/g, "");
      setItems(
        list.map((pnr) => ({
          _id: pnr?._id,
          airlinePnr: sanitize(pnr?.airlinePnr ?? ""),
        })),
      );
    }
  }, [open, initialPnrList]);

  const handleItemChange = (index, value) => {
    const lettersAndNumbersOnly = (value ?? "").replace(/[^a-zA-Z0-9]/g, "");
    setItems((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, airlinePnr: lettersAndNumbersOnly } : item,
      ),
    );
  };

  const onSave = () => {
    const list = items.map((item) => ({
      ...item,
      airlinePnr: (item.airlinePnr ?? "").trim(),
    }));
    const hasEmpty = list.some((item) => !item.airlinePnr);
    if (hasEmpty) {
      enqueueSnackbar("All Airline PNRs must be filled.", {
        variant: "warning",
      });
      return;
    }
    handleSave(list);
  };

  return (
    <Modal3 open={open} setOpen={setOpen} title="Edit Airline PNR">
      <div className="card p-6 flex flex-col gap-5 min-w-[24rem] max-h-[80vh] overflow-y-auto">
        {items.map((item, index) => (
          <div key={item._id ?? index} className="flex-1">
            <CommonFreeTextInput
              value={item.airlinePnr}
              onChange={(value) => handleItemChange(index, value)}
              label={`Airline PNR ${index + 1}`}
            />
          </div>
        ))}
        <div className="flex gap-3 items-center justify-end pt-2">
          <Button1
            variant="outlined"
            className="whitespace-nowrap"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button1>
          <Button1 onClick={onSave}>Save Airline PNR</Button1>
        </div>
      </div>
    </Modal3>
  );
}

export default TicketEditAirlinePnrModal;
